<item-feed [itemHeight]="imageHeight" [itemsPerRow]="itemsPerRow" [selectedId]="selectedPath" [selectedIndex]="selectedIndex" (itemClick)="emitItemClickEvent($event)">
    <ng-template let-item="item" let-index="index">
        <image-with-artifacts [cellData]="item" [placeholderSize]="imageHeight"></image-with-artifacts>
    </ng-template>
</item-feed>
